import loadable from '@loadable/component';
import React, { Component, ErrorInfo, ReactElement, ReactNode } from 'react';
import ErrorScreen from 'Douleutaras/layout/service-pages/ErrorScreen';
import { CaptureException } from 'Douleutaras/providers/CaptureException';

interface Props {
  children: ReactNode;
  showLayout: boolean;
}

interface State {
  hasError: boolean;
}

const ErrorWithLayout = () => {
  const DefaultFullLayout = loadable(() => import(/* webpackPrefetch: false */'Douleutaras/layout/DefaultFullLayout'));

  return <DefaultFullLayout>
    <ErrorScreen />
  </DefaultFullLayout>;
};

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  };

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // tslint:disable-next-line
  componentDidCatch(error, errorInfo) {
    CaptureException(error, errorInfo);
  }

  render(): ReactElement | ReactNode {
    if (this.state.hasError) {
      if (this.props.showLayout) {
        return <ErrorWithLayout />;
      }

      return <ErrorScreen />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
